import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControlLabel, IconButton, Switch, Tooltip } from "@mui/material";
import { IconPencil, IconPlus } from "@tabler/icons-react";
import PaginatedTable from "../Common/Tables/table";
import { IconTrash } from "@tabler/icons-react/dist/esm/tabler-icons-react";

export const ActionCell = ({
  row,
  showAddButton = false,
  handleEditDialog = () => {},
  handleAddDialog = () => {},
  handleDeleteDialog = () => {},
  handleSwitch = () => {},
  hideEditIcon,
  hideDeleteIcon,
  hideAddIcon,
  showToggle = false,
}) => {
  const [enable, setEnable] = useState(row?.original?.isEnabled);
  
  useEffect(() => {
    setEnable(row?.original?.isEnabled);
  }, [row?.original?.isEnabled]);
  
  return (
    <>
      {!hideEditIcon && (
        <IconButton onClick={() => handleEditDialog(row)}>
          <IconPencil size={"1.8rem"} />
        </IconButton>
      )}
      {/* {!hideDeleteIcon && (
        <IconButton onClick={() => handleDeleteDialog(row)}>
          <IconTrash size={"1.8rem"} />
        </IconButton>
      )} */}
      {!hideAddIcon && (
        <Tooltip title="Add Users">
          <IconButton onClick={() => handleAddDialog(row)}>
            <IconPlus size={"1.8rem"} />
          </IconButton>
        </Tooltip>
      )}
      {showToggle && (
        <Tooltip title="Enable/Disable">
          <FormControlLabel
            control={
              <Switch
                checked={enable}
                onChange={(e) => {
                  setEnable(e.target.checked);
                  handleSwitch(e, row?.original?.uuid);
                }}
              />
            }
          />
        </Tooltip>
      )}
    </>
  );
};

const FeatureTableComponent = ({
  data = [],
  columns = [],
  totalCount,
  isFetching,
  offset,
  setOffSet,
  search,
  limit,
  setLimit,
  setSearch,
  handleAddEnterPrise,
  expandedRows,
  handleUserEditDialog,
  setUserRow,
  expandedRowsData,
  handleSortPaginatedTable,
  setSortStateExpanded,
  sortStateExpanded,
  columnsExpandableTable,
  hideFeatureButton,
  hideEditIcon,
  hideDeleteIcon,
  hideAddIcon,
}) => {
  return (
    <PaginatedTable
      heading={"Features"}
      data={data}
      columns={columns}
      totalCount={totalCount}
      headingButtonText={"Add Feature"}
      headingBtnClick={handleAddEnterPrise}
      expandedRows={expandedRows}
      columnsExpandableTable={columnsExpandableTable}
      expandableTableData={expandedRowsData}
      expandableTableCount={expandedRowsData?.length}
      hideFeatureButton={hideFeatureButton}
      hideEditIcon={hideEditIcon}
      hideDeleteIcon={hideDeleteIcon}
      hideAddIcon={hideAddIcon}
      // expandableTableLoading={getAllOrgUsersLoading}
    />
  );
};

FeatureTableComponent.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  row: PropTypes.object,
  handleAddEnterPrise: PropTypes.func,
  offset: PropTypes.number,
  limit: PropTypes.number,
  totalCount: PropTypes.number,
  expandedRows: PropTypes.object,
  handleUserEditDialog: PropTypes.func,
  setUserRow: PropTypes.func,
  setLimit: PropTypes.func,
  setSearch: PropTypes.func,
  isFetching: PropTypes.bool,
  setOffSet: PropTypes.func,
  search: PropTypes.func,
  expandedRowsData: PropTypes.object,
  setSortStateExpanded: PropTypes.func,
  sortStateExpanded: PropTypes.object,
};

export default FeatureTableComponent;
